import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { useStateService } from '@/shared/services/StateService';
import messages from '../generalSettingsMessages';
const LegalEntityManagedNotice = ({ legalEntityId, legalEntityName, }) => {
    const intl = useIntl();
    const stateService = useStateService();
    return (_jsxs("span", Object.assign({ className: "form-control-static" }, { children: [_jsx("i", { className: "fa fa-info-circle margin5R text-muted" }), intl.formatMessage(messages.ManagedByLegalEntity, { name: legalEntityName }), _jsx("a", Object.assign({ className: "clickable margin5L", onClick: () => stateService.gotoState('settings.legalEntities', { id: legalEntityId }), title: intl.formatMessage(messages.OpenLegalEntity) }, { children: _jsx("i", { className: "fa fa-external-link" }) }))] })));
};
export default LegalEntityManagedNotice;
